/**
 * remove duplicate value from Photos json object.
 * @param json 
 * @returns 
 */
export function removeDuplicateFromPhotosJson(json:Object):Record<string,string>{
  const keys = Object.keys(json);
  keys.filter((key) => key !== 'thumbs')
  const tempAraay = []
  const newResult = {}
  for (const key of keys) {
    const val = json[key];
    if(!tempAraay.includes(val)){
      tempAraay.push(val)
      newResult[key] = val
    }else{
      newResult[key] = ""
    }
  }

  return newResult;
}
